import { DBInsert, DBFind, DBRemove, DBFindOne } from '@weblite/persist'

const collectionName = 'draftSync'
interface StoredSyncDraft {
  roomId: string
  date: number
}

export async function set(roomId: string, date: number) {
  await DBInsert(collectionName, { roomId, date })
  return async function unset() {
    const draft = await DBFindOne(collectionName, roomId)
    if (draft?.date === date) await DBRemove(collectionName, roomId)
  }
}

export async function getAll() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const storedSyncDrafts: StoredSyncDraft[] = await DBFind(collectionName)

  async function del() {
    await Promise.all(
      storedSyncDrafts.map(async ({ date, roomId }) => {
        const draft = await DBFindOne(collectionName, roomId)
        if (draft?.date === date) await DBRemove(collectionName, roomId)
      }),
    )
  }
  return { storedSyncDrafts, del }
}
